
import React from 'react';
import { useTournament } from '@/hooks/use-tournament';
import { TournamentLeaderboard } from '../shared/TournamentLeaderboard';

export const AmericanoLeaderboard: React.FC = () => {
  const { tournamentState, startTournament } = useTournament();

  // Debug: Check if joinedAt data is present
  React.useEffect(() => {
    console.log('🎯 AmericanoLeaderboard players:', tournamentState.americanoPlayers.map(p => ({
      name: p.name,
      joinedAt: p.joinedAt
    })));
  }, [tournamentState.americanoPlayers]);

  const handleRestartTournament = () => {
    // Get the current players and restart with them
    const players = tournamentState.americanoPlayers.map(p => ({
      id: p.id,
      name: p.name,
      points: 0,
      matchesPlayed: 0
    }));
    
    // Restart the tournament with the same players and same type
    const tournamentType = tournamentState.tournamentType || 'americano';
    startTournament(players, 0, tournamentType as 'americano' | 'team_americano');
  };

  return (
    <TournamentLeaderboard
      players={tournamentState.americanoPlayers}
      currentRound={tournamentState.currentRound}
      isFinished={tournamentState.isFinished}
      tournamentType="americano"
      onRestartTournament={handleRestartTournament}
    />
  );
};
